/** @jsxImportSource @emotion/react */
import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Icon,
  Toaster,
} from "@coreai/component-library";
import { Link, useLocation } from "react-router-dom";
// import agwLogo from "../../../assets/agw_logo.svg";
import "./NavigationBar.css";
import { useNavBarLabelsService } from "../../../services/useNavBarLabelsService";
import { useUserDataService } from "../../../services/useUserDataService";
import UserButton from "./UserButton";
// import Loader from "../Loader/Loader";
import { useLanguage } from "../../../LanguageContext";
import LanguageDropdown from "./LanguageDropdown";
import { css, useTheme } from "@emotion/react"
import { useAuthPageCheck } from "hooks/useAuthPageCheck";

const NavigationBar: React.FC = () => {
   const theme = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { navbarLabels, loading, error } = useNavBarLabelsService();
  const {
    userData,
    loading: userLoading,
    error: userError,
  } = useUserDataService();
  const { language, setLanguage } = useLanguage();
  const { isAuthPage } = useAuthPageCheck();

  useEffect(() => {
    if (userData?.localeCode) {
      setLanguage(userData.localeCode);
    }
  }, [userData]);

  useEffect(() => {
    // Find the first <svg> inside the ButtonIcon component    
    const icons = document.querySelectorAll("svg");
    icons.forEach((icon) => {
      // Get the "name" attribute from the <svg>
      const iconName = icon.getAttribute("name");
      if (iconName) {
        icon.setAttribute("role", "img");
        icon.setAttribute("aria-label", iconName.replace("-", " ")); // Convert "edit-01" → "edit 01"
      } else {
        icon.setAttribute("aria-hidden", "true"); // Hide if no name is available
      }
    });     
  }, []);
  
  if (error) console.log(error);
  if (userError) console.log(userError);

  const environment = process.env?.REACT_APP_ENVIRONMENT || '';
  const showBannerOnlyOn  = ['uat','qc','dev','test'];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toasterWraper = css`
    position: absolute;
    top: 0px;
    right: 0px;
    @media (max-width: 640px) {
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 1000;
    width: 90%;
  }
  `;


  const bannerStyle = css`
    position: absolute;
    width: 100%;
    border: 2px solid ${theme.colors.red};
    bottom: 0;
    left: 0;

    &::after {
      content: attr(data-env);
      position: absolute;
      width: 120px;
      height: 16px;
      background-color: ${theme.colors.red};
      border-radius: 0 0 4PX 4PX;
      left: 50%;
      top: 100%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 9px;
      font-family: Inter;
      font-weight: 600;
    }
  `;

  const navigationBar = css`
    .language-selector {
      button {
        padding: 5px;
        overflow: hidden;
      }
    }
  `;

  const centerNavigationBar = css`
    justify-content: center !important;
  `;
  const labelCss = css`
    visibility: hidden;
    position: absolute;
  `;
  return (
    <Container variant="row" className="navigation-bar" css={[navigationBar, isAuthPage && centerNavigationBar]} >
      <div className="logo-container">
        <Link to="/" className="logo-link">
          {
            (navbarLabels?.logo) && (
              <img src={navbarLabels?.logo} alt="Logo" className="agw-logo" />
            )
          }
          <h1 className="app-title">{navbarLabels?.title || ""}</h1>
        </Link>
      </div>
      { !isAuthPage && <>
        <div className={`nav-actions ${isMenuOpen ? "open" : ""}`}>
          <div className="nav-link langue language-selector menu-burger-exclude">
            <LanguageDropdown />
          </div>
          <div className="menu-burger-exclude">
            <UserButton
              className="user-link"
              name={userData?.name ?? ""}
              jobTitle={userData?.position ?? ""}
              img={userData?.picture ?? ""}
              email={userData?.email ?? ""}
              isAdmin={userData?.isAdmin}
              is_llid_user={userData?.is_llid_user}
            />
          </div>
        </div>
        <Container variant="row" className="navigation-bar-mobile">
          <Link className="nav-link-contact" to="/contact">
            <div
              style={{
                color: theme.colors.textMedium,
                paddingTop: "6px",
                position: 'relative',
              }}
            >
              <Icon name="mail" size="md" />
              <div css={labelCss}>Contact</div>
            </div>
          </Link>
          <div className="nav-link langue">
            <LanguageDropdown />
          </div>
          <UserButton
            className="user-link"
            name={userData?.name ?? ""}
            jobTitle={userData?.position ?? ""}
            img={userData?.picture ?? ""}
            email={userData?.email ?? ""}
            isAdmin={userData?.isAdmin}
            is_llid_user={userData?.is_llid_user}
          />
        </Container>
      </> }
      <div css={toasterWraper}>
        <Toaster />
      </div>
      {showBannerOnlyOn?.includes(environment?.toLowerCase()) && <div css={bannerStyle} data-env={environment}></div>}
    </Container>
  );
};

export default NavigationBar;